import React, { useState } from "react";
import MainTitle from "components/Common/MainTitle";
import { sendInquiry } from "../../helpers/inquiryApi";

function SectionMap() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [hp, setHp] = useState("");
  const [status, setStatus] = useState({ type: "", text: "" });
  const [submitting, setSubmitting] = useState(false);

  const emailOk = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus({ type: "", text: "" });

    if (!firstName.trim() || !lastName.trim()) {
      setStatus({ type: "error", text: "Please enter your first and last name." });
      return;
    }
    if (!emailOk(email)) {
      setStatus({ type: "error", text: "Please enter a valid email address." });
      return;
    }
    if (!message.trim()) {
      setStatus({ type: "error", text: "Please enter a message." });
      return;
    }

    setSubmitting(true);
    try {
      await sendInquiry({
        type: "contact",
        source: "contact-map",
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        phone: phone.trim(),
        email: email.trim(),
        message: message.trim(),
        _hp: hp,
      });
      setStatus({
        type: "ok",
        text: "Thank you — your message has been sent. We will get back to you shortly.",
      });
      setFirstName("");
      setLastName("");
      setPhone("");
      setEmail("");
      setMessage("");
      setHp("");
    } catch (err) {
      setStatus({
        type: "error",
        text: err.message || "Something went wrong. Please try again or call us directly.",
      });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <>
      <div className="container my-5 ContactMain ">
        <div className="row">
          <div className="col-md-5 p-0">
            <div className="d-flex justify-content-end">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5028.518965560287!2d72.5806217579987!3d23.114963055720768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e83ac30f361e5%3A0x27853233a2e5cb72!2sSouth%20Asia%20Consultancy!5e0!3m2!1sen!2sin!4v1706520416905!5m2!1sen!2sin"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="South Asia Consultancy office location map"
                style={{
                  width: "526px",
                  height: "628px",
                }}
              ></iframe>
            </div>
          </div>
          <div className="col-md-7 ">
            <MainTitle text={"Get in touch "} className="my-4 mt-5" />
            <div>
              {status.text ? (
                <div
                  className={`alert ${status.type === "ok" ? "alert-success" : "alert-danger"} my-3`}
                  role="status"
                >
                  {status.text}
                </div>
              ) : null}
              <form onSubmit={handleSubmit} noValidate>
                <div
                  className="position-absolute"
                  style={{ left: "-10000px", width: "1px", height: "1px", overflow: "hidden" }}
                  aria-hidden="true"
                >
                  <label htmlFor="contact-map-hp">Leave blank</label>
                  <input
                    type="text"
                    id="contact-map-hp"
                    tabIndex={-1}
                    autoComplete="off"
                    value={hp}
                    onChange={(e) => setHp(e.target.value)}
                  />
                </div>
                <div className="my-4">
                  <input
                    type="text"
                    placeholder="First Name"
                    className="CustomInputContactInput mr-2 p-2"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    autoComplete="given-name"
                  />

                  <input
                    type="text"
                    placeholder="Last Name"
                    className="CustomInputContactInput p-2"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    autoComplete="family-name"
                  />
                </div>

                <div className="my-2">
                  <input
                    type="tel"
                    placeholder="Phone"
                    className="CustomInputContactInput  mr-2 p-2"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    autoComplete="tel"
                  />

                  <input
                    type="email"
                    placeholder="Email"
                    className="CustomInputContactInput p-2"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                  />
                </div>
                <textarea
                  placeholder="Your message"
                  className="CustomInputContactTextArea p-2 my-2 mb-4"
                  rows={4}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
                <div className="">
                  <button
                    type="submit"
                    className=" btn   ContactPageBtn  my-4"
                    disabled={submitting}
                  >
                    {submitting ? "Sending…" : "Submit Now"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionMap;
